'use client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import authClient from '@/common/apiClient/authClient';
import { userLogin } from '@/slices/userSlice';

const CRUser = () => {
    const dispatch = useDispatch();

    // 取得 user 資訊
    const fetchUser = async () => {
        try {
            const data = await authClient.getUser();

            if (data?.user) dispatch(userLogin(data?.user));
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    return <></>;
};

export default CRUser;
